import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { formatTimeDifference } from "../../../../common/Validations";
import "./ShowStatus.css";

const getIcon = (action) => {
  const map = {
    Created: "bi-pencil-square text-primary",
    Pending: "bi-hourglass-split text-warning",
    Approve: "bi-check-circle-fill text-success",
    Submit: "bi-send-fill text-info",
    Reject: "bi-x-circle-fill text-danger",
    Completed: "bi-flag-fill text-success",
  };
  return map[action] || "bi-circle";
};

const getBadgeClass = (action) => {
  const map = {
    Created: "badge-created",
    Pending: "badge-pending",
    Approve: "badge-approved",
    Submit: "badge-submit",
    Reject: "badge-reject",
    Completed: "badge-complete",
  };
  return map[action] || "badge-default";
};

const ShowStatus = React.forwardRef((props, ref) => {
  const [loadData, setLoadData] = useState(
    props?.rowdatamodal?.workflowActionLogs || props?.rowdatamodal,
  );

  useEffect(() => {
    setLoadData(props?.rowdatamodal);

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  return (
    <Modal
      {...props}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      ref={ref}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-diagram-3 me-2"></i>
          {props.modeltitle} –{" "}
          {loadData?.length > 0 ? loadData[0]?.businessComponentInstanceId : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={12}>
            <div className="timeline">
              {loadData?.length > 0 &&
                loadData.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-icon">
                      <i className={`bi ${getIcon(item.currentAction)}`}></i>
                    </div>

                    <div className="timeline-content">
                      <div className="timeline-header">
                        <span
                          className={`status-badge ${getBadgeClass(
                            item.currentAction,
                          )}`}
                        >
                          {item.currentAction}
                        </span>

                        <span className="timeline-time">
                          {formatTimeDifference(item.updatedAt)}
                          <br></br>
                           {new Date(item.updatedAt).toLocaleString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </span>
                        {/* <span className="time-stamp">
                          <i
                            className="bi bi-calendar3 me-1"
                            style={{
                              fontSize: "0.7rem",
                            }}
                          ></i>
                          {new Date(item.updatedAt).toLocaleString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </span> */}
                      </div>

                      {item?.approveresInfo?.map((user, i) => (
                        <div key={i} className="timeline-user">
                          <div className="fw-semibold">
                            {user.userId} –{" "}
                            {user.firstName || user.organisationName}
                          </div>
                          <div className="text-muted small">{user.email}</div>
                        </div>
                      ))}

                      {item?.remark && (
                        <div className="timeline-remark">{item.remark}</div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default ShowStatus;
